<header class="player-count">
  <app-icon icon="podium" />
  <span>{{ playersCount() }}</span>
</header>
<ul #rankList>
  @for (entry of visibleEntries(); track entry.player.user.username) {
    <li
      app-player-item
      [attr.data-rank-player]="entry.player.user.username"
      [player]="entry.player"
      [index]="entry.position"
    ></li>
  }
</ul>
